// ═══════════════════════════════════════════════════════════════════
//  modules/erp/PlayerBouxTab.js
//  PlayerBouxTab
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { BOUX_VARIETIES } from "./boux";
import { BouxXpBar } from "./BouxXpBar";

export function PlayerBouxTab({ uuid, token }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/players/${uuid}/boux`, { headers: { Authorization: `Bearer ${token}` } });
      const json = await res.json();
      setData(json);
    } catch (err) { console.error(err); }
    setLoading(false);
  }, [token, uuid]);
  useEffect(() => { load(); }, [uuid, load]);

  if (loading) return <div style={{ color: THEME.textMuted }}>Chargement des Boux...</div>;
  if (!data) return <div style={{ color: THEME.red }}>Erreur de chargement.</div>;

  if (data.unavailable) return (
    <div style={{ color: THEME.amber, background: THEME.amberDim, border: `1px solid ${THEME.amber}`, borderRadius: 8, padding: "12px 16px", fontSize: 13 }}>
      ⏳ Le module Boux n'est pas encore disponible (tables non créées). Les données apparaîtront ici une fois le plugin Boux installé.
    </div>
  );

  const bouxMap = {};
  (data.boux || []).forEach(b => { bouxMap[b.variete] = b; });
  const primordiaux = BOUX_VARIETIES.filter(v => v.type === 'primordial');
  const hybrides = BOUX_VARIETIES.filter(v => v.type === 'hybride');

  const renderBouxCard = (variety) => {
    const b = bouxMap[variety.key];
    const unlocked = b && b.debloque;
    const isActive = data.state && data.state.variete_active === variety.key;
    return (
      <div key={variety.key} style={{
        background: unlocked ? THEME.panel : THEME.surface,
        border: `1px solid ${isActive ? variety.color : unlocked ? THEME.border : THEME.border}`,
        borderRadius: 10, padding: 14, opacity: unlocked ? 1 : 0.5,
        position: "relative"
      }}>
        {isActive && (
          <div style={{ position: "absolute", top: 8, right: 8, background: variety.color + "33", color: variety.color, fontSize: 9, fontWeight: 700, padding: "2px 6px", borderRadius: 4 }}>ACTIF</div>
        )}
        <div style={{ fontSize: 28, marginBottom: 6 }}>{variety.emoji}</div>
        <div style={{ color: unlocked ? THEME.text : THEME.textDim, fontSize: 13, fontWeight: 700, marginBottom: 4 }}>{variety.label}</div>
        {variety.fusion && (
          <div style={{ color: THEME.textDim, fontSize: 10, marginBottom: 6 }}>Fusion : {variety.fusion.join(' + ')}</div>
        )}
        {unlocked && b ? (
          <>
            <BouxXpBar niveau={b.niveau} xp={b.xp} color={variety.color} />
            <button disabled style={{
              marginTop: 10, width: "100%",
              background: THEME.surface, border: `1px solid ${THEME.border}`,
              color: THEME.textDim, borderRadius: 6, padding: "7px 8px",
              cursor: "not-allowed", fontSize: 11, fontWeight: 600
            }}>⏳ En attente de validation de Brice</button>
          </>
        ) : (
          <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 6 }}>Non débloqué</div>
        )}
      </div>
    );
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {data.state && (
        <div style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, borderRadius: 8, padding: "10px 14px", fontSize: 12 }}>
          <span style={{ color: THEME.accent, fontWeight: 700 }}>Boux actif : </span>
          <span style={{ color: THEME.text }}>{data.state.variete_active || "Aucun"}</span>
          {data.state.online_server && <span style={{ color: THEME.textMuted, marginLeft: 10 }}>· En ligne sur {data.state.online_server}</span>}
        </div>
      )}
      <div>
        <div style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 700, marginBottom: 10, textTransform: "uppercase" }}>Boux Primordiaux</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
          {primordiaux.map(renderBouxCard)}
        </div>
      </div>
      <div>
        <div style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 700, marginBottom: 10, textTransform: "uppercase" }}>Boux Hybrides</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
          {hybrides.map(renderBouxCard)}
        </div>
      </div>
      <div style={{ color: THEME.textDim, fontSize: 11, textAlign: "center" }}>
        {(data.boux || []).filter(b => b.debloque).length} / {BOUX_VARIETIES.length} Boux débloqués
      </div>
    </div>
  );
}
